const NS = 'FlipCardTileBlock';
const CLS = 'flipCardTileBlock';

export class FlipCardTileBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$card = this.$element.find(`.${CLS}-card`);
		this.isFlipped = false;

		this.$element.on(`${CLS}.flip`, () => {
			this.flipCard();
		});

		this.$element.on('click', () => {
			this.flipCard();
		});

		this.adjustPersepective();
		$(window).resize(_.debounce(() => {
			this.adjustPersepective();
		}, 50));

		this.lockParentScroll();

		this.$element.css({
			visibility: 'visible'
		});
	}

	flipCard() {
		let isFlipped = this.$card.hasClass(`${CLS}-card--flipped`);

		if(isFlipped) {
			this.$card.removeClass(`${CLS}-card--flipped`);
			this.isFlipped = false;
		}
		else {
			this.$card.addClass(`${CLS}-card--flipped`);
			this.isFlipped = true;
		}
	}

	adjustPersepective() {
		this.$element.css({
			perspective: this.$card.width() * 4
		});
	}

	/**
	 * Locks the parent scroll assuming the fixedScrollMixin is implemented.
	 * [fixed-scroll-event] is generated by the fixedScrollMixin
	 * Used in conjunction with overscrollBehaviour: https://developer.mozilla.org/en-US/docs/Web/CSS/overscroll-behavior
	 */
	lockParentScroll() {
		this.$element.on('click', () => {
			if(this.isFlipped) {
				lockFixedScroll();
			}
		});

		this.$element.on('mouseenter', _.throttle(() => {
			if(this.isFlipped) {
				lockFixedScroll();
			}
		}, 50, { leading: true, trailing: true }));

		this.$element.on('mouseleave touchend', _.throttle(() => {
			if(this.isFlipped) {
				let $fixedScrollEvent = this.$element.parents().find('[fixed-scroll-event]');
				if($fixedScrollEvent && $fixedScrollEvent.length > 0) {
					$fixedScrollEvent.removeAttr('fixed-scroll-event-lock');
				}
			}
		}, 50, { leading: true, trailing: true }));

		let lockFixedScroll = () => {
			let $fixedScrollEvent = this.$element.parents().find('[fixed-scroll-event]');
			if($fixedScrollEvent && $fixedScrollEvent.length > 0) {
				$fixedScrollEvent.attr('fixed-scroll-event-lock', 'true');
			}
		};
	}
}
